var initSticky = function (container) {
    $(container).theiaStickySidebar({
        additionalMarginTop : 10
    });
};

jQuery(document).ready(function($){
    initSticky('.main, .sidebar');
});